module.exports = __webpack_public_path__ + "static/media/google-play.a9f1b09e.svg";